const KEY = 'game-v1'

export function loadState () {
  try {
    const serializedState = localStorage.getItem(KEY)
    if (!serializedState) return undefined
    return JSON.parse(serializedState)
  } catch (e) {
    return undefined
  }
}

export async function saveState (state) {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem(KEY, serializedState)
  } catch (e) {
    // Ignore
  }
}

export function clearState () {
  try {
    localStorage.removeItem(KEY)
  } catch (e) {
    // Ignore
  }
}
